var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-indicator text-center"},[_c('p',[_vm._v("YOU ARE IMPERSONATING "+_vm._s(_vm.profile.email))]),_c('a',{staticClass:"font-weight-bold text-decoration-underline",attrs:{"role":"button"},on:{"click":function($event){return _vm.$store.dispatch('logout')}}},[_vm._v(" Become "+_vm._s(_vm.fallbackTokenData.email)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }